import AOS from 'aos';

(function () {
    function prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    /** Calm scroll reveals: not disabled on mobile — only when user requests reduced motion. */
    var options = {
        duration: 480,
        easing: 'ease-out-cubic',
        once: true,
        offset: 48,
        delay: 0,
        startEvent: 'load',
        disable: prefersReducedMotion,
    };

    AOS.init(options);
})();
